import { useState, useRef, useEffect } from "react";

const randomHexColor = () => {
  return `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0")}`.toUpperCase();
};
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  notification,
  OrdemServicosStatusPersonalizadosService,
} from "../../../../services";
import {
  Button,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Tooltip,
  // Chip,
  TextField,
  DialogContent,
} from "../../../../components";
import palette from "../../../../styles/dark-theme/palette";
import { statusPersonalizadoOsValidator } from "../../middlewares";
import { responseErros } from "../../../../utils";
import { InputBase } from "@mui/material";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

function ItemStatusServico({
  descricao,
  fixed = false,
  prov = null,
  id = null,
  onEdit,
  onDelete,
  editing = false,
  editingValue = "",
  onEditingChange = () => {},
  editingRef = null,
  onSaveEdit = () => {},
  onCancelEdit = () => {},
  pos = null,
  handleOpenInsertAt = () => {},
  showAddOnFixed = false,
  onColorChange = null,
  cor = null,
}) {
  // const colorInputRef = useRef(null);

  // const handleColorClick = () => {
  //   colorInputRef.current?.click();
  // };

  return (
    <Box
      {...(prov ? prov.dragHandleProps : {})}
      className="w-100 p-4 rounded-4 gap-3 d-flex flex-column"
      sx={{
        background: fixed ? "var(--bs-gray-100)" : "#f0f8ff",
        cursor: fixed ? "default" : "grab",
        height: "10rem",
        position: "relative",
      }}
    >
      <Box className="w-100 d-flex justify-content-between">
        {editing ? (
          <TextField
            fullWidth
            placeholder="Descrição do status"
            value={editingValue}
            onChange={(e) => onEditingChange(e.target.value)}
            inputRef={editingRef}
            size="small"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSaveEdit(id);
              } else if (e.key === "Escape") {
                onCancelEdit();
              }
            }}
            onBlur={() => {
              if (String(editingValue || "").trim()) onSaveEdit(id);
              else onCancelEdit();
            }}
          />
        ) : (
          <div className="d-flex gap-2 align-items-center">
            <InputBase
              type="color"
              value={cor}
              onChange={(e) => {
                if (!fixed) onColorChange(id, e.target.value);
              }}
              disabled={fixed}
              sx={{
                width: 15,
                height: 15,
                padding: 0,
                borderRadius: 1,
                overflow: "hidden",
                "& input": {
                  padding: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                  background: "none",
                  cursor: fixed ? "default" : "pointer",
                },
                "& input::-webkit-color-swatch-wrapper": {
                  padding: 0,
                },
                "& input::-webkit-color-swatch": {
                  border: "none",
                },
              }}
            />

            <Typography
              variant="h6"
              className="fw-bold"
              sx={{
                fontSize: 12,
                color: fixed ? "var(--bs-gray-600)" : "#6380b6",
              }}
            >
              {descricao}
            </Typography>
            {!fixed && (
              <IconButton
                onClick={() => onEdit && onEdit(id)}
                sx={{
                  width: 2,
                  height: 2,
                }}
              >
                <Tooltip title="Editar" arrow placement="right">
                  <i
                    className="ph-fill ph-pencil-simple-line"
                    style={{ fontSize: 16 }}
                  ></i>
                </Tooltip>
              </IconButton>
            )}
          </div>
        )}

        {!fixed && !editing && (
          <div>
            <IconButton
              color="error"
              onClick={() => onDelete && onDelete(id)}
              sx={{
                width: 2,
                height: 2,
              }}
            >
              <Tooltip title="Deletar" arrow placement="bottom">
                <i
                  className="ph-fill ph-trash"
                  style={{
                    fontSize: 16,
                    color: "#e44a42",
                  }}
                />
              </Tooltip>
            </IconButton>
          </div>
        )}
      </Box>
      {(!fixed || showAddOnFixed) && (
        <>
          <Box
            className="w-100 h-100 rounded-2"
            sx={{ background: "#2195f3", opacity: 0.06 }}
          ></Box>
          <Box
            sx={{
              zIndex: 100,
              position: "absolute",
              right: "-1.85rem",
              top: "50%",
              transform: "translateY(-50%)",
              border: "0.4rem solid white",
            }}
            className="rounded-circle"
          >
            <AddBetweenButton
              index={pos}
              onAdd={() => handleOpenInsertAt(pos + 1)}
            />
          </Box>
        </>
      )}
    </Box>
  );
}

function AddBetweenButton({ index, onAdd }) {
  return (
    <Box
      onClick={() => onAdd(index)}
      sx={{
        cursor: "pointer",
        transition: "transform 0.2s",
        pointerEvents: "auto",
        "&:hover": {
          transform: "scale(1.1)",
        },
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: 30,
          height: 30,
          background: "#1976d2",
        }}
      >
        <i className="ph ph-plus" style={{ color: "#fff", fontSize: 15 }} />
      </div>
    </Box>
  );
}

const ordemServicosStatusPersonalizadosService =
  new OrdemServicosStatusPersonalizadosService();

export const StatusPersonalizadoOsDialog = ({ open, setOpen }) => {
  const TEMP_ID = "__temp__";
  const [{ columnsMap, columnOrder }, setState] = useState({
    columnsMap: {},
    columnOrder: [],
  });
  const [inlineInputRef, editInputRef] = [useRef(null), useRef(null)];

  const [newStatus, setNewStatus] = useState("");
  const [insertionIndex, setInsertionIndex] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [idsRemoved, setIdsRemoved] = useState([]);
  const [editingValue, setEditingValue] = useState("");

  const useScroll = (columnOrder || []).length >= 4;
  const minCardWidth = 240;

  useEffect(() => {
    if (open) {
      buscarStatusPersonalizados();
    }
  }, [open]);

  const handleColorChange = (colId, newColor) => {
    setState((prev) => {
      const cols = { ...(prev.columnsMap || {}) };
      if (!cols[colId]) return prev;
      cols[colId] = { ...cols[colId], cor: newColor };
      return { ...prev, columnsMap: cols };
    });
  };

  const buscarStatusPersonalizados = async () => {
    const response = await ordemServicosStatusPersonalizadosService.getAll();
    if (!response.isAxiosError) {
      const ordered = Array.isArray(response.data)
        ? [...response.data].sort(
            (a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0),
          )
        : [];
      setState({
        columnsMap: ordered.reduce((acc, item) => {
          acc[String(item.id)] = item;
          return acc;
        }, {}),
        columnOrder: ordered.map((item) => String(item.id)),
      });
    } else responseErros(response);
  };

  const handleEditStart = (colId) => {
    setEditingId(colId);
    setEditingValue(
      (columnsMap && columnsMap[colId] && columnsMap[colId].descricao) || "",
    );
    setTimeout(() => {
      editInputRef.current?.focus();
    }, 60);
  };

  const handleSaveEdit = (colId) => {
    const desc = String(editingValue || "").trim();
    if (!desc) return handleCancelEdit();
    setState((prev) => {
      const cols = { ...(prev.columnsMap || {}) };
      if (!cols[colId]) return prev;
      cols[colId] = { ...cols[colId], descricao: desc.toUpperCase() };
      return { ...prev, columnsMap: cols };
    });
    setEditingId(null);
    setEditingValue("");
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditingValue("");
  };

  function onClose() {
    setState({
      columnsMap: {},
      columnOrder: [],
    });
    setNewStatus("");
    setInsertionIndex(null);
    setEditingId(null);
    setEditingValue("");
    setOpen(false);
  }

  const handleOpenInsertAt = (index) => {
    setState((prev) => {
      const order = Array.from(prev.columnOrder);
      if (order.includes(TEMP_ID)) return prev;
      order.splice(index, 0, TEMP_ID);
      return {
        ...prev,
        columnOrder: order,
        columnsMap: {
          ...prev.columnsMap,
          [TEMP_ID]: {
            id: TEMP_ID,
            descricao: "",
            cor: randomHexColor(),
            isTemporary: true,
          },
        },
      };
    });

    setTimeout(() => {
      inlineInputRef.current?.focus();
    }, 60);
  };

  const handleSaveNewStatus = () => {
    const desc = String(newStatus || "").trim();
    if (!desc) return handleCancelInsert();
    const newId = `col-${Date.now()}`;
    setState((prev) => {
      const order = prev.columnOrder.map((id) => (id === TEMP_ID ? newId : id));
      const newCols = { ...prev.columnsMap };
      const assignedColor =
        (newCols[TEMP_ID] && newCols[TEMP_ID].cor) || randomHexColor();
      delete newCols[TEMP_ID];
      newCols[newId] = {
        id: newId,
        descricao: desc.toUpperCase(),
        cor: assignedColor,
      };
      return {
        columnOrder: order,
        columnsMap: newCols,
      };
    });
    setNewStatus("");
    setInsertionIndex(null);
  };

  const handleCancelInsert = () => {
    setState((prev) => {
      const order = prev.columnOrder.filter((id) => id !== TEMP_ID);
      const cols = { ...prev.columnsMap };
      delete cols[TEMP_ID];
      return {
        columnOrder: order,
        columnsMap: cols,
      };
    });
    setInsertionIndex(null);
    setNewStatus("");
  };

  const onDragEnd = (result) => {
    const { destination, source, type } = result;
    if (!destination) return;

    if (type === "COLUMN") {
      if (source.index === destination.index) return;
      setState((prev) => ({
        ...prev,
        columnOrder: reorder(prev.columnOrder, source.index, destination.index),
      }));
      return;
    }
  };

  const handleDeleteStatus = (colId) => {
    const current = columnsMap[colId];
    if (!current || current.fixed) return;
    notification
      .confirmacao("Tem certeza que deseja excluir este status?")
      .then(({ isConfirmed }) => {
        if (isConfirmed) {
          setState((prev) => {
            const newCols = { ...prev.columnsMap };
            delete newCols[colId];
            return {
              columnsMap: newCols,
              columnOrder: prev.columnOrder.filter((id) => id !== colId),
            };
          });
          if (current && typeof current.id === "number") {
            setIdsRemoved((prev) => [...prev, current.id]);
          }
        }
      });
  };

  function onSubmit() {
    const columns = columnOrder.map((id, index) => ({
      id: columnsMap[id].id,
      descricao: columnsMap[id].descricao,
      ordem: index + 1,
      cor: columnsMap[id]?.cor ?? randomHexColor(),
    }));
    statusPersonalizadoOsValidator
      .validate(columns, { abortEarly: false })
      .then(async () => {
        const result = await ordemServicosStatusPersonalizadosService.cadastrar(
          { idsRemoved, columns },
        );
        if (!result.isAxiosError) {
          notification.alteracaoSucesso();
          onClose();
        } else {
          responseErros(result);
        }
      })
      .catch((err) => {
        console.error("Erro na validação:", err);
      });
  }

  return (
    <Dialog
      fullWidth
      maxWidth="full"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "1.5rem",
          background: `linear-gradient(180deg, ${palette.primary.main} 1.5%, ${palette.white} 1.5%, ${palette.white} 98%)`,
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <CardContent>
          <CardHeader
            title="Status Personalizado (Ordem de Serviço)"
            subheader={
              <Typography variant="body2" className="pt-1" gutterBottom>
                Organize os status personalizados para suas ordens de serviço
              </Typography>
            }
            action={
              <IconButton
                color="inherit"
                onClick={onClose}
                sx={{
                  backgroundColor: "#EDEEF0",
                  "&:hover": { backgroundColor: "#B6BABC" },
                }}
              >
                <i
                  className="ph-bold ph-x"
                  style={{ fontSize: "clamp(17px, 4vw, 20px)" }}
                ></i>
              </IconButton>
            }
          />
          <Box sx={{ p: 2, overflowX: "hidden" }}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Box
                className="mb-4"
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  width: "100%",
                  overflowX: "hidden",
                }}
              >
                <Box sx={{ minWidth: minCardWidth, flex: "0 0 auto" }}>
                  <ItemStatusServico
                    descricao="ABERTO"
                    fixed
                    pos={-1}
                    cor="#4FBB53"
                    showAddOnFixed={!(columnOrder && columnOrder.length > 0)}
                    handleOpenInsertAt={handleOpenInsertAt}
                  />
                </Box>

                <Droppable
                  droppableId="all-columns"
                  direction="horizontal"
                  type="COLUMN"
                >
                  {(provided) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: 2,
                        alignItems: "flex-start",
                        position: "relative",
                        ...(useScroll
                          ? {
                              flex: "1 1 0",
                              minWidth: 0,
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                            }
                          : { flex: "1 1 0", minWidth: 0 }),
                      }}
                    >
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 16,
                          alignItems: "flex-start",
                          position: "relative",
                          ...(useScroll
                            ? {
                                flex: "1 1 0",
                                minWidth: 0,
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                              }
                            : { flex: "1 1 0", minWidth: 0 }),
                        }}
                      >
                        {columnOrder && columnOrder.length > 0
                          ? Array.from({ length: columnOrder.length + 1 }).map(
                              (_, pos) => {
                                const elements = [];
                                if (pos < columnOrder.length) {
                                  const colId = String(columnOrder[pos]);
                                  const col = columnsMap[colId];

                                  if (insertionIndex === pos) {
                                    elements.push(
                                      <Box
                                        key={`insert-${pos}`}
                                        sx={
                                          useScroll
                                            ? {
                                                minWidth: minCardWidth,
                                                flex: "0 0 auto",
                                              }
                                            : { flex: "1 1 0", minWidth: 0 }
                                        }
                                      >
                                        <div
                                          className="w-100 p-4 rounded-4 d-flex flex-column"
                                          style={{
                                            background: "#fff",
                                            height: "10rem",
                                            position: "relative",
                                            border: "1px dashed #cfd8dc",
                                          }}
                                        >
                                          <TextField
                                            fullWidth
                                            placeholder="Descrição do status"
                                            value={newStatus}
                                            onChange={(e) =>
                                              setNewStatus(e.target.value)
                                            }
                                            inputRef={inlineInputRef}
                                            size="small"
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSaveNewStatus();
                                              } else if (e.key === "Escape") {
                                                handleCancelInsert();
                                              }
                                            }}
                                            onBlur={() => {
                                              if (
                                                String(newStatus || "").trim()
                                              )
                                                handleSaveNewStatus();
                                              else handleCancelInsert();
                                            }}
                                          />
                                        </div>
                                      </Box>,
                                    );
                                  }
                                  if (col?.isTemporary) {
                                    elements.push(
                                      <Box
                                        key={TEMP_ID}
                                        sx={
                                          useScroll
                                            ? {
                                                minWidth: minCardWidth,
                                                flex: "0 0 auto",
                                              }
                                            : { flex: "1 1 0", minWidth: 0 }
                                        }
                                      >
                                        <div
                                          className="w-100 p-4 rounded-4 d-flex flex-column"
                                          style={{
                                            background: "#fff",
                                            height: "10rem",
                                            border: "1px dashed #cfd8dc",
                                          }}
                                        >
                                          <TextField
                                            fullWidth
                                            placeholder="Descrição do status"
                                            value={newStatus}
                                            onChange={(e) =>
                                              setNewStatus(e.target.value)
                                            }
                                            inputRef={inlineInputRef}
                                            size="small"
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSaveNewStatus();
                                              } else if (e.key === "Escape") {
                                                handleCancelInsert();
                                              }
                                            }}
                                            onBlur={() => {
                                              if (
                                                String(newStatus || "").trim()
                                              )
                                                handleSaveNewStatus();
                                              else handleCancelInsert();
                                            }}
                                          />
                                        </div>
                                      </Box>,
                                    );
                                  } else {
                                    elements.push(
                                      <Draggable
                                        key={String(col.id)}
                                        draggableId={String(col.id)}
                                        index={pos}
                                      >
                                        {(prov) => {
                                          const wrapperStyle = {
                                            display: "flex",
                                            flex: useScroll
                                              ? "0 0 auto"
                                              : "1 1 0",
                                            minWidth: useScroll
                                              ? minCardWidth
                                              : 0,
                                            alignItems: "flex-start",
                                            position: "relative",
                                            gap: 16,
                                            ...prov.draggableProps.style,
                                          };

                                          return (
                                            <div
                                              ref={prov.innerRef}
                                              {...prov.draggableProps}
                                              {...prov.dragHandleProps}
                                              data-draggable-id={String(col.id)}
                                              style={wrapperStyle}
                                            >
                                              <Box
                                                sx={
                                                  useScroll
                                                    ? {
                                                        minWidth: minCardWidth,
                                                        flex: "0 0 auto",
                                                      }
                                                    : {
                                                        flex: "1 1 0",
                                                        minWidth: 0,
                                                      }
                                                }
                                              >
                                                <ItemStatusServico
                                                  descricao={col.descricao}
                                                  prov={prov}
                                                  id={String(col.id)}
                                                  onEdit={handleEditStart}
                                                  onDelete={handleDeleteStatus}
                                                  editing={
                                                    editingId === String(col.id)
                                                  }
                                                  editingValue={editingValue}
                                                  onEditingChange={
                                                    setEditingValue
                                                  }
                                                  editingRef={editInputRef}
                                                  onSaveEdit={handleSaveEdit}
                                                  onCancelEdit={
                                                    handleCancelEdit
                                                  }
                                                  pos={pos}
                                                  handleOpenInsertAt={
                                                    handleOpenInsertAt
                                                  }
                                                  cor={col?.cor}
                                                  onColorChange={
                                                    handleColorChange
                                                  }
                                                />
                                              </Box>
                                            </div>
                                          );
                                        }}
                                      </Draggable>,
                                    );
                                  }
                                }

                                return elements;
                              },
                            )
                          : insertionIndex !== null && (
                              <Box
                                sx={
                                  useScroll
                                    ? {
                                        minWidth: minCardWidth,
                                        flex: "0 0 auto",
                                      }
                                    : { flex: "1 1 0", minWidth: 0 }
                                }
                              >
                                <div
                                  className="w-100 p-4 rounded-4 d-flex flex-column"
                                  style={{
                                    background: "#fff",
                                    height: "10rem",
                                    position: "relative",
                                    border: "1px dashed #cfd8dc",
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    placeholder="Descrição do status"
                                    value={newStatus}
                                    onChange={(e) =>
                                      setNewStatus(e.target.value)
                                    }
                                    inputRef={inlineInputRef}
                                    size="small"
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSaveNewStatus();
                                      } else if (e.key === "Escape") {
                                        handleCancelInsert();
                                      }
                                    }}
                                    onBlur={() => {
                                      if (String(newStatus || "").trim())
                                        handleSaveNewStatus();
                                      else handleCancelInsert();
                                    }}
                                  />
                                </div>
                              </Box>
                            )}
                        {provided.placeholder}
                      </div>
                    </Box>
                  )}
                </Droppable>
                <Box sx={{ minWidth: minCardWidth, flex: "0 0 auto" }}>
                  <ItemStatusServico descricao="FECHADO" fixed cor="#004780" />
                </Box>
              </Box>
            </DragDropContext>
            <Typography
              variant="body2"
              className="pt-1 text-center w-100"
              gutterBottom
            >
              Arraste para reordenar os status personalizados
            </Typography>
          </Box>
        </CardContent>
        <DialogActions className="mx-3">
          <Button
            onClick={onClose}
            variant="contained"
            color="padrao"
            disableElevation
          >
            Fechar
          </Button>
          <Button
            onClick={onSubmit}
            variant="contained"
            disableElevation
            className="px-4"
          >
            Salvar
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
